import { ComponentType, Suspense, lazy, useEffect } from 'react';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import Fallback from './components/Fallback';
import { ROUTER_BASENAME } from './constants/config';
import layout from './layout';
import { pwaReady } from './utils/pwa';

type PageLoader = () => Promise<{ default: ComponentType }>;

const pages = import.meta.glob('./pages/**/*.tsx') as Record<string, PageLoader>;
const routes: {
    path: string;
    Element: React.ComponentType;
}[] = [];

Object.keys(pages).forEach((path) => {
    const fileName = path.match(/\.\/pages\/(.*)\.tsx$/)?.[1];
    if (!fileName) return;

    const normalizedPathName = fileName.replace('$', ':').replace(/\/index/, '');

    routes.push({
        path: fileName === 'index' ? '/' : `/${normalizedPathName.toLowerCase()}`,
        Element: lazy(async () => ({ default: layout((await pages[path]()).default) })),
    });
});

routes.push({
    path: '*',
    Element: lazy(pages['./pages/404.tsx']),
});

const router = createBrowserRouter(
    routes.map(({ Element, ...rest }) => ({
        ...rest,
        Component: Element,
    })),
    { basename: window.location.pathname.startsWith('/buses') ? '/buses/support' : '/support' },
);

function App() {
    useEffect(() => {
        pwaReady();
    }, []);

    return (
        <Suspense fallback={<Fallback />}>
            <RouterProvider router={router} />
        </Suspense>
    );
}

export default App;
